import { appColors } from "@/constants/color";
export const themes = {
  // light: {
  //   mode: 'light',
  //   colors: {
  //     // Base colors
  //     background: appColors.themePageBg,
  //     text: appColors.summaryPrimaryText,
  //     caption: appColors.summaryCaptionText,
  //     primary: appColors.themeSecondaryAction,
  //     primary: appColors.themeSecondaryAction,
  //     destructive: appColors.themeDestructiveText,

  //     // Surface colors
  //     card: appColors.surfaceBase,
  //     cardSecondary: appColors.panelMutedBg,

  //     // Border colors
  //     border: appColors.inputBorderStrong,
  //     borderLight: appColors.softBorder,
  //     borderDark: appColors.placeholderMuted,

  //     // Status colors
  //     error: appColors.themeErrorBase,
  //     warning: appColors.statusDueText,
  //     success: appColors.themeSuccessText,
  //     info: appColors.themeInfoText,

  //     successBackground :appColors.statusPaidBg,
  //     desctructiveBackground : appColors.themeDestructiveBg,

  //     // Interactive colors
  //     disabled: appColors.themeDisabledText,
  //     disabledLight : appColors.mutedBorderOverlay,

  //     active: appColors.themeActiveText,
  //     hover: appColors.themeHoverBg,

  //     // Input colors
  //     inputBackground: appColors.panelMutedBg,
  //     inputBorder: appColors.themeInputBorder,
  //     placeholder: appColors.placeholderMuted,

  //     // Focus/outline
  //     outline: appColors.contentInk,
  //     focusRing: appColors.themeFocusRing,

  //   },
  //   spacing: {
  //     xs: 4,
  //     sm: 8,
  //     md: 16,
  //     lg: 24,
  //     xl: 32,
  //   },
  //   fontSize: {
  //     h1: 32,
  //     h2: 28,
  //     h3: 24,
  //     h4: 20,
  //     h5: 18,
  //     h6: 16,
  //     body: 14,
  //     caption: 12,
  //   },
  //   radius: {
  //     xs: 4,
  //     sm: 8,
  //     md: 12,
  //     lg: 16,
  //     xl: 24,
  //     xxl: 32,
  //   },
  //   opacity: {
  //     disabled: 0.5,
  //     subtle: 0.8,
  //   },
  // },

  light: {
    mode: 'light',
    colors: {
      //?Neutral
      neutralPrimary: appColors.themeNeutralBorder,
      neutralBase: appColors.themeNeutralBase,
      neutralSecondary: appColors.themeNeutralSecondaryBg,
      neutralLine: appColors.themeNeutralBorder,

      //?Primary

      primary: appColors.contentInk,
      primaryHover: appColors.themePrimaryHover,
      primaryPressed: appColors.themePrimaryPressed,
      primaryBackground: appColors.themePrimarySoftBg,

      //?Secondary

      // secondary: appColors.themeSecondarySoftBg,

      //?Success

      success: appColors.themeSuccessText,
      successHover: appColors.themeSuccessHover,
      successPressed: appColors.themeSuccessPressed,
      successBackground: appColors.themeSuccessSoftBg,

      //?Warning

      warning: appColors.themeWarningBase,
      warningHover: appColors.themeWarningHover,
      waringPressed: appColors.themeWarningPressed,
      warningBackground: appColors.themeWarningSoftBg,

      //?Error or Danger

      error: appColors.themeErrorText,
      errorHover: appColors.themeErrorHover,
      errorPressed: appColors.themeErrorPressed,
      errorBackground: appColors.themeErrorSoftBg,

      //?text

      text: appColors.themeBodyText,
      secondaryText: appColors.themeSecondaryText,
      disabledText: appColors.themeDisabledTextOverlay,

      // Base colors
      // background: appColors.themePageBg,
      background: appColors.themeNeutralBase,
      // text: appColors.summaryPrimaryText,
      caption: appColors.summaryCaptionText,
      // primary: appColors.themeSecondaryAction,
      secondary: appColors.themeSecondaryAction,
      destructive: appColors.themeDestructiveText,

      // Surface colors
      card: appColors.surfaceBase,
      cardSecondary: appColors.panelMutedBg,

      // Border colors
      border: appColors.inputBorderStrong,
      borderLight: appColors.softBorder,
      borderDark: appColors.placeholderMuted,

      // Status colors
      // error: appColors.themeErrorBase,
      // warning: appColors.statusDueText,
      // success: appColors.themeSuccessText,
      info: appColors.themeInfoText,

      // successBackground: appColors.statusPaidBg,
      desctructiveBackground: appColors.themeDestructiveBg,

      // Interactive colors
      // disabled: appColors.themeDisabledText,
      disabled: appColors.themeDisabledBg,
      active: appColors.themeActiveText,
      hover: appColors.themeHoverBg,
      inputDisabled: appColors.themeInputDisabledText,

      // Input colors
      inputBackground: appColors.panelMutedBg,
      inputBorder: appColors.themeInputBorder,
      placeholder: appColors.placeholderMuted,

      // Focus/outline
      outline: appColors.contentInk,
      focusRing: appColors.themeFocusRing,
    },
    spacing: {
      xs: 4,
      sm: 8,
      md: 16,
      lg: 24,
      xl: 32,
    },
    fontSize: {
      h1: 32,
      h2: 28,
      h3: 24,
      h4: 20,
      h5: 18,
      h6: 16,
      body: 14,
      caption: 12,
    },
    radius: {
      xs: 4,
      sm: 8,
      md: 12,
      lg: 16,
      xl: 24,
      xxl: 32,
    },
    opacity: {
      disabled: 0.5,
      subtle: 0.8,
    },
  },
  dark: {
    mode: 'dark',
    colors: {
      //? Neutral

      neutralPrimary: appColors.themeDarkNeutralPrimary,
      neutralBase: appColors.themeDarkSurface,
      neutralSecondary: appColors.themeDarkNeutralSecondary,
      neutralLine: appColors.themeDarkNeutralLine,

      //? text

      primaryText: appColors.themeDarkPrimaryText,
      secondaryText: appColors.themeDarkSecondaryText,
      disabledText: appColors.themeDarkDisabledText,
    },
  },
};

export type ThemeType = typeof themes.light;
